import { Box, Text } from '@jfs/ui-new'
import { ButtonNew } from '../AdminButton'
import { IconOptions } from '@jfs/ui-new/src/comps/IconNew'
import { StatusIndicator } from '../StatusIndicator'
import styles from './styles'

interface LeftDataProps {
  title?: string
  status?: 'active' | 'scheduled' | 'completed'
  subtitle?: Array<string>
}

const renderLeftData = ({ title, status, subtitle }: LeftDataProps) => {
  return (
    <Box {...styles.leftAligned}>
      <Box direction={'row'} align={'center'}>
        <Text {...styles.headerText}>{title}</Text>
        {status ? (
          <Box pl={10}>
            <StatusIndicator type={status} />
          </Box>
        ) : null}
      </Box>
      <Text {...styles.subtitleText}>{subtitle?.join('   >   ')}</Text>
    </Box>
  )
}

interface RightDataProps {
  firstType?: 'primary' | 'secondary'
  secondType?: 'primary' | 'secondary'
  firstTitle?: string
  secondTitle?: string
  firstOnPress?: () => void
  secondOnPress?: () => void
  firstButtonDisabled?: boolean
  secondButtonDisabled?: boolean
  firstButtonIcon?: string
  secondButtonIcon?: string
  secondLoader?: boolean
  firstLoader?: boolean
}

const renderRightData = ({
  firstType,
  firstTitle,
  firstOnPress,
  secondType,
  secondTitle,
  secondOnPress,
  firstButtonDisabled,
  secondButtonDisabled,
  firstButtonIcon,
  secondButtonIcon,
  secondLoader,
  firstLoader,
}: RightDataProps) => {
  const firstButton: any = () =>
    firstOnPress ? (
      <ButtonNew
        type={firstType === 'primary' ? 'primary' : 'secondary'}
        title={firstTitle || 'Cancel'}
        isLoading={firstLoader}
        onPress={firstOnPress}
        icon={firstButtonIcon as IconOptions}
        disabled={firstButtonDisabled ?? false}
      />
    ) : null

  const secondButton: any = () =>
    secondOnPress ? (
      <Box ml={firstOnPress ? 15 : 0}>
        <ButtonNew
          isLoading={secondLoader}
          type={secondType === 'secondary' ? 'secondary' : 'primary'}
          title={secondTitle || 'Save Changes'}
          onPress={secondOnPress}
          icon={secondButtonIcon as IconOptions}
          disabled={secondButtonDisabled ?? false}
        />
      </Box>
    ) : null

  return (
    <Box {...styles.rightAligned}>
      {firstButton()}
      {secondButton()}
    </Box>
  )
}

interface HeaderProps {
  left?: LeftDataProps
  right?: RightDataProps
}

const Header = ({ left, right }: HeaderProps) => {
  return (
    <Box {...styles.mainHeaderView}>
      {left && renderLeftData(left)}
      {right ? renderRightData(right) : null}
    </Box>
  )
}

export { Header }
